<div class="flex flex-col h-full">
  <div class="flex-1 min-h-0">
    <ag-charts *ngIf="options" [options]="options" style="width: 100%; height: 100%; display: block"></ag-charts>
    <div *ngIf="isPageReady && !options" class="flex items-center justify-center h-full text-gray-500">
      No items shipped in the last 6 months.
    </div>
  </div>
</div>
